
import styles from'./MyPage.module.scss';
import React, { useState, useEffect } from 'react';
import common from '../../../common';
import DatePicker from 'react-datepicker';
import { ko } from 'date-fns/locale';
import { FaCalendarDay } from 'react-icons/fa';
import axios from 'axios';


import { useSelector } from 'react-redux';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function MyPage() {

    
    const loginIdx = useSelector((state) => state.user.loginInfo);

    const { pToast, useAlert, useConfirm, useLoading, useDatePickerMonth, useModal } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pConfirm, ConfirmComponent } = useConfirm();

    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();
    const { pModal, ModalComponent } = useModal(); // 훅 사용

    const [formData, setFormData] = useState({
        thumbnail: '',
        thumbnailPreview: '',
        email: '',
        name: '',
        code: '',
        password: '',
        password_confirm: '',
        phone: '',
        birth: '',
        address: '',
        addressDetail: '',
        gradeName: '',
        statusName: '',
        createTime: '',
        job: '',
        forumIDX: 0,
        future: '',
        keyword: '',
        careerPack: [],
        universityPack: [],
        forumList: [],
        statusIDX: '',
        eventHistory: [],
        documentHistory : [],
        organization : [],
    });

    const [selectedData, setSelectedData] = useState(null); // 데이터테이블 선택 시 디테일 

    useEffect(() => {

        

        const fetchDetailData = async () => {
            try {
                pLoadingOn();
                const response = await axios.post(`${API_BASE_URL}/yehs_my_page/in/get_detail`, { member_idx: loginIdx }, {
                    withCredentials: true
                });
    
                if (response.data.result === 't') {
                    const data = response.data.data;

                    const formattedPhone = formatPhoneNumber(data.phone || '');


                    if (data) {
                        setFormData(prevFormData => ({
                            ...prevFormData,
                            member_idx: data.idx,
                            thumbnail: data.thumbnail || '',
                            thumbnailPreview: data.thumbnailPreview || '',
                            email: data.email || '',
                            name: data.name || '',
                            code: data.code || '',
                            password: data.password || '',
                            password_confirm: data.password_confirm || '',
                            phone: formattedPhone,
                            birth: data.birth || '', 
                            address: data.address || '', 
                            addressDetail: data.addressDetail || '', 
                            statusName: data.statusName || '',
                            gradeName: data.gradeName || '',
                            createTime: data.createTime || '',
                            future: data.future || '',
                            keyword: data.keyword || '',
                            job: data.job || '',
                            universityPack: data.university && data.university.length > 0
                                ? data.university.map((item, index) => ({
                                    idx: item.idx || (index + 1),
                                    university: item.university,
                                    major: item.major,
                                    degree: item.degree,
                                    degreeAttend: item.degreeAttend,
                                    status: 'U'
                                }))
                                : [{ idx: 1, university: '', major: '', status: 'I', degree: '1', degreeAttend: '1' }],
                            careerPack: data.career && data.career.length > 0
                                ? data.career.map((item, index) => ({
                                    idx: item.idx || (index + 1),
                                    career: item.career || '',
                                    status: 'U'
                                }))
                                : [{ idx: 1, career: '', status: 'I' }],

                            statusIDX: data.statusIDX || '',
                            forumIDX: data.forumIDX || 0,
                            forumList: data.forumList || [],
                            eventHistory: data.eventHistory || [],
                            documentHistory: data.documentHistory || [],
                            organization: data.organization || [],
                        }));

                        setSelectedData(prevFormData => ({
                            ...prevFormData,
                            member_idx: data.idx,
                            thumbnail: data.thumbnail || '',
                            thumbnailPreview: data.thumbnailPreview || '',
                            email: data.email || '',
                            name: data.name || '',
                            code: data.code || '',
                            password: data.password || '',
                            password_confirm: data.password_confirm || '',
                            phone: formattedPhone,
                            birth: data.birth || '', 
                            address: data.address || '', 
                            addressDetail: data.addressDetail || '', 
                            statusName: data.statusName || '',
                            gradeName: data.gradeName || '',
                            createTime: data.createTime || '',
                            future: data.future || '',
                            keyword: data.keyword || '',
                            job: data.job || '',
                            universityPack: data.university && data.university.length > 0
                                ? data.university.map((item, index) => ({
                                    idx: item.idx || (index + 1),
                                    university: item.university,
                                    major: item.major,
                                    degree: item.degree,
                                    degreeAttend: item.degreeAttend,
                                    status: 'U'
                                }))
                                : [{ idx: 1, university: '', major: '', status: 'I', degree: '1', degreeAttend: '1' }],
                            careerPack: data.career && data.career.length > 0
                                ? data.career.map((item, index) => ({
                                    idx: item.idx || (index + 1),
                                    career: item.career || '',
                                    status: 'U'
                                }))
                                : [{ idx: 1, career: '', status: 'I' }],
                
                            statusIDX: data.statusIDX || '',
                            forumIDX: data.forumIDX || 0,
                            forumList: data.forumList || [],
                            eventHistory: data.eventHistory || [],
                            documentHistory: data.documentHistory || [],
                            organization: data.organization || [],
                        }));
                    }
                } else {
                    pAlert(response.data.msg);
                }
            } catch (error) {
                console.error('Data fetching failed:', error);
            } finally {
                pLoadingOff();
            }
        }
        fetchDetailData();
        
    }, []);

    // 기본 인풋 변경
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };

    // 기본 인풋 숫자로 변경
    const handleNumberChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: parseInt(value, 10), // 문자열을 숫자로 변환
        }));
    };

    // 휴대폰 번호 형식
    const formatPhoneNumber = (input) => {
        input = input.replace(/\D/g, ''); // 숫자만 남기기

        if (input.length > 3 && input.length <= 7) {
            return `${input.slice(0, 3)}-${input.slice(3)}`;
        } else if (input.length > 7) {
            return `${input.slice(0, 3)}-${input.slice(3, 7)}-${input.slice(7, 11)}`;
        }
        return input;
    };

    // 휴대폰 번호 변경시
    const handlePhoneNumberChange = (e) => {
        const formattedInput = formatPhoneNumber(e.target.value);
        setFormData(prevFormData => ({
            ...prevFormData,
            phone: formattedInput,
        }));
    };


    

    const handleClick = () => {
        new window.daum.Postcode({
            oncomplete: (data) => {
                setFormData({
                    ...formData,
                    address: data.address,
                });
            },
        }).open();
    };




    // 날짜 형식 변환
    const formattedDate = (data) => {
        return data.toISOString().split('T')[0]; // yyyy-MM-dd 형식으로 변환
    }

    // 생년월일 날짜 수정
    const handleDateChange = (date) => {
        setFormData(prevFormData => ({
            ...prevFormData,
            birth: formattedDate(date)
        }));
    };

    // ==================== 경력 ====================

    // 경력 인풋 변경 시
    const handleCareerChange = (idx, field, value) => {
        setFormData(prevFormData => {
            const updatedCareers = prevFormData.careerPack.map((box, index) =>
                box.idx === idx ? { ...box, [field]: value, idx: box.idx || (index + 1), status: box.status === 'I' ? 'I' : 'U' } : box
            );
            return { ...prevFormData, careerPack: updatedCareers };
        });
    };

    // 경력 + 버튼
    const handleAddCareerBox = () => {
        setFormData(prevFormData => ({
            ...prevFormData,
            careerPack: [
                ...prevFormData.careerPack,
                { idx: prevFormData.careerPack.length + 1, career: '', status: 'I' }
            ]
        }));
    };

    // 경력 - 버튼
    const handleRemoveCareerBox = (idx) => {
        setFormData(prevFormData => {
            const selectedItems = selectedData ? selectedData.careerPack : [];
            const selectedItem = selectedItems.find(item => item.idx === idx);

            if (!selectedItem) {
                return {
                    ...prevFormData,
                    careerPack: prevFormData.careerPack.map(item =>
                        item.idx === idx ? { ...item, status: 'F' } : item
                    )
                };
            }

            return {
                ...prevFormData,
                careerPack: prevFormData.careerPack.map(item =>
                    item.idx === idx ? { ...item, status: 'D' } : item
                )
            };
        });
    };
    

    // ==================== 학력 ====================

    // 학력 인풋 변경 시
    const handleSchoolChange = (idx, field, value) => {
        setFormData(prevFormData => {
            const updatedSchools = prevFormData.universityPack.map(box =>
                box.idx === idx ? { ...box, [field]: value, status: box.status === 'I' ? 'I' : 'U' } : box
            );
            return { ...prevFormData, universityPack: updatedSchools };
        });
    };

    // 학력 + 버튼
    const handleAddUniversityBox = (field) => {
        setFormData(prevFormData => ({
            ...prevFormData,
            [field]: [
                ...prevFormData[field],
                { idx: (prevFormData[field].length + 1), university: '', major: '', degree: '1', degreeAttend: '1' , status: 'I' }
            ]
        }));
    };
    
    // 학력 - 버튼
    const handleRemoveUniversityBox = (field, idx) => {
        setFormData(prevFormData => {
            const selectedItems = selectedData[field] || [];
            const selectedItem = selectedItems.find(item => item.idx === idx);
            
            // selectedData에 없는 항목은 무시
            if (!selectedItem) {
                return {
                    ...prevFormData,
                    [field]: prevFormData[field].map(item =>
                        item.idx === idx ? { ...item, status: 'F' } : item
                    )
                };
            }
    
            return {
                ...prevFormData,
                [field]: prevFormData[field].map(item =>
                    item.idx === idx ? { ...item, status: 'D' } : item
                )
            };
        });
    };
    
    
















    

    // 파일 변경 시
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    thumbnail: file,
                    thumbnailPreview: reader.result
                }));
            };
            reader.readAsDataURL(file);
        }
    };

    
    // 
    const handleThumbnailClick = () => {
        document.getElementById('thumbnailUpload').click();
    };





    // 수정 버튼
    const handleSubmit = async () => {
        let newFormData = {};
        let newUpdateFormData = new FormData();
    
        // 변경된 데이터만 추출하여 newFormData에 저장
        Object.keys(formData).forEach(key => {
            if (Array.isArray(formData[key])) {
                // 배열인 경우 각 항목을 비교하여 변경된 항목만 newFormData에 추가
                const changedItems = formData[key].filter((item, index) => {
                    const selectedItem = (selectedData[key] || []).find(selectedItem => selectedItem.idx === item.idx);
                    return (JSON.stringify(item) !== JSON.stringify(selectedItem) || item.status === 'D') && item.status !== 'F';
                });
                if (changedItems.length > 0) {
                    newFormData[key] = changedItems;
                }
            } else if (formData[key] !== selectedData[key]) {
                newFormData[key] = formData[key];
            }
        });
    
        // console.log('newFormData:', newFormData);
        const targetIdx = formData.member_idx;
        newUpdateFormData.append('targetIdx', targetIdx);
    
        // newFormData의 데이터를 newUpdateFormData에 추가
        Object.entries(newFormData).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                newUpdateFormData.append(key, JSON.stringify(value));
            } else {
                newUpdateFormData.append(key, value);
            }
        });
    
        // for (let pair of newUpdateFormData.entries()) {
        //     console.log('newUpdateFormData 여기서 확인',`${pair[0]}: ${pair[1]}`);
        // }
    
        if (Object.keys(newFormData).length === 0) {
            pAlert('변경된 내용이 없습니다.');
            return false;
        }
    
        pConfirm(
            '수정',
            <>
                <div>내용을 수정 하시겠습니까?</div>
            </>,
            '400px',
            'auto',
            async () => {
                try {
                    pLoadingOn();
                    const response = await axios.post(`${API_BASE_URL}/yehs_my_page/in/update_my_info`, newUpdateFormData, {
                        withCredentials: true,
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });
                    if (response.data.result === 't') {
                        pAlert('수정이 완료되었습니다.');
                        setTimeout(() => {
                            window.location.reload();
                        },1000);
                        
                    } else {
                        pAlert(response.data.msg);
                    }
                } catch (error) {
                    console.error('Data fetching failed:', error);
                    pAlert('데이터 전송에 실패했습니다. 다시 시도해주세요.');
                } finally {
                    pLoadingOff();
                }
            }
        );
    };


    return (
        <>
            <ModalComponent />
            <AlertComponent />
            <ConfirmComponent />
            <LoadingComponent />
            <div className={styles.components_wrap}>
                <div className={styles.detail_wrap}>
                    <div className={styles.detail_title}>내 정보</div>
                    {/* {data ? ( */}
                        <div className={styles.detail_info_box}>


                            <div className={styles.member_thumbnail_img_box}>
                                <div
                                    className={styles.member_thumbnail_img}
                                    style={{ backgroundImage: `url(${formData.thumbnailPreview || formData.thumbnail || 'default_image_url'})` }}
                                    onClick={handleThumbnailClick}
                                ></div>
                                <input
                                    id="thumbnailUpload"
                                    type="file"
                                    style={{ display: 'none' }}
                                    onChange={handleFileChange}
                                    accept="image/*"
                                />
                            </div>


                            <div className={styles.detail_flex_wrap}>
                                <div className={styles.detail_left_box}>




                                    <div className={styles.detail_info}>
                                        <span className={styles.info_title}>회원번호</span>
                                        <span
                                            className={`${styles.info_cont}`} autoComplete="name"
                                        >{formData.code}</span>
                                        {/* <input type="text" name="code" value={formData.code} placeholder='회원번호' className={`${styles.info_cont}`} onChange={handleInputChange} /> */}
                                    </div>



                                    
                                    <div className={styles.detail_info}>
                                        <span className={styles.info_title}>이메일</span>
                                        <span
                                            className={`${styles.info_cont}`} autoComplete="name"
                                        >{formData.email}</span>
                                        {/* <input type="text" placeholder='이메일' name="email" value={formData.email} className={`${styles.info_cont}`} onChange={handleInputChange} /> */}
                                    </div>




                                    
                                    


                                    <form action="">


                                        <div className={styles.detail_info}>
                                            <span className={styles.info_title}>이름</span>
                                            {/* <input
                                                type="text"
                                                placeholder="이름"
                                                name="name"
                                                value={formData.name}
                                                className={`${styles.info_cont}`}
                                                onChange={handleInputChange}
                                                autoComplete="name"
                                            /> */}
                                            <span
                                                className={`${styles.info_cont}`} 
                                                autoComplete="name"
                                            >{formData.name}</span>

                                        </div>




                                        <div className={styles.detail_info}>
                                            <span className={styles.info_title}>비밀번호 수정</span>
                                            <input
                                                type="password"
                                                placeholder="비밀번호"
                                                name="password"
                                                value={formData.password}
                                                className={`${styles.info_cont}`}
                                                onChange={handleInputChange}
                                                autoComplete="new-password"
                                            />
                                            <span className={styles.info_important}>비밀번호 변경시에만 적어주세요.</span>
                                        </div>





                                        <div className={styles.detail_info}>
                                            <span className={styles.info_title}>비밀번호 확인</span>
                                            <input
                                                type="password"
                                                placeholder="비밀번호 확인"
                                                name="password_confirm"
                                                value={formData.password_confirm}
                                                className={`${styles.info_cont}`}
                                                onChange={handleInputChange}autoComplete="new-password"

                                            />
                                            <span className={styles.info_important}>비밀번호 변경시에만 적어주세요.</span>
                                        </div>
                                    </form>




                                    

                                    



                                    <div className={styles.detail_info}>
                                        <span className={styles.info_title}>생년월일</span>
                                        <div className={styles.info_date_cont}>
                                            <DatePicker
                                                locale={ko}
                                                selected={formData.birth ? new Date(formData.birth) : null}
                                                onChange={handleDateChange}
                                                name="birth"
                                                className={`${styles.detail_datePicker} pDatePicker`}
                                                dateFormat="yyyy-MM-dd"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                            />
                                            <FaCalendarDay className={`${styles.calendarIcon} calendarIcon`} />
                                        </div>
                                    </div>



                                    <div className={styles.detail_info}>
                                        <span className={styles.info_title}>전화번호</span>
                                        <input
                                            type="text"
                                            placeholder="전화번호"
                                            name="phone"
                                            value={formData.phone}
                                            className={styles.info_cont}
                                            onChange={handlePhoneNumberChange}
                                        />
                                    </div>
                                    






                                    <div className={styles.detail_info}>
                                        <div className={`${styles.join_form_box}  display_flex`}>
                                            <span className={styles.info_title}>주소</span>
                                            <button
                                                className={styles.address_btn}
                                                onClick={handleClick}
                                                >
                                                주소 검색
                                            </button>
                                        </div>
                                        
                                        <input
                                            type="text"
                                            className={`${styles.info_cont}`}
                                            placeholder="주소"
                                            name="address"
                                            value={formData.address}
                                            onChange={handleInputChange}
                                        />
                                        <input
                                            type="text"
                                            className={`${styles.info_cont}`}
                                            placeholder="상세주소"
                                            name="addressDetail"
                                            value={formData.addressDetail}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    








                                    {/* <div className={styles.detail_info}>
                                        <span className={styles.info_title}>상태</span>
                                        <select className={`${styles.info_select}`} name="statusIDX" value={formData.statusIDX ?? ''} onChange={handleNumberChange}>
                                            <option value="601101">정상</option>
                                            <option value="601203">비밀번호재설정필요</option>
                                            <option value="601204">차단</option>
                                        </select>
                                    </div> */}





                                    <div className={styles.detail_info}>
                                        <span className={styles.info_title}>참여포럼 및 입회시기</span>
                                        <select 
                                            className={styles.info_select}
                                            value={formData.forumIDX ?? ''}
                                            name="forumIDX" 
                                            onChange={handleNumberChange}
                                        >
                                            <option value="0">참여포럼 없음</option>
                                            {formData.forumList.map((forum, index) => (
                                                <option
                                                    key={index}
                                                    value={forum.idx}
                                                >
                                                    {forum.time}회 / [{forum.year}년 {forum.month}월]
                                                </option>
                                            ))}
                                        </select>
                                    </div>








                                    <div className={styles.detail_info}>
                                        <span className={styles.info_title}>진로</span>
                                        <select className={`${styles.info_select}`} name="future" value={formData.future ?? ''} onChange={handleNumberChange}>
                                            <option value="0">미정</option>
                                            <option value="1">대학생</option>
                                            <option value="2">대학원생</option>
                                            <option value="3">취업(직장생활)</option>
                                        </select>
                                    </div>




                                    <div className={styles.detail_info}>
                                        <span className={styles.info_title}>등급명</span>
                                        <span className={`${styles.info_cont}`}>{formData.gradeName}</span>
                                        {/* <span className={styles.info_important}>등급은 회원 등급에서 변경할 수 있습니다.</span> */}
                                    </div>



                                </div>
                                {/* detail_left_box */}



                                <div className={styles.detail_right_box}>
                                    <div className={styles.select_box_container}>
                                        {formData.organization && formData.organization.length > 0 ? (
                                            formData.organization.map((item, index) => (
                                                <div className={styles.detail_info} style={{paddingBottom:"0px"}} key={index}>
                                                    {index === 0 ? (
                                                        <>
                                                            <span className={styles.info_title}>YEHS 경력</span>
                                                            <div className={styles.info_cont}>
                                                                {item.yearName} {item.deptName} {item.position}
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <div className={styles.info_cont}>
                                                            <span className={styles.info_title}></span>
                                                            {item.yearName} {item.deptName} {item.position}
                                                        </div>
                                                    )}
                                                </div>
                                            ))
                                        ) : (
                                            <div className={styles.detail_info}>
                                                <span className={styles.info_title}>YEHS 경력</span>
                                                <div className={styles.info_cont}>-</div>
                                            </div>
                                        )}
                                        <span className={styles.info_important}>조직구성에 등록된 내용이며 이름이 다를 경우 담당자에게 문의 바랍니다.</span>
                                    </div>






                                    <div className={styles.detail_info}>
                                        <span className={styles.info_title}>키워드</span>
                                        <input type="text" name="keyword" value={formData.keyword} placeholder='키워드1, 키워드2' className={`${styles.info_cont}`} onChange={handleInputChange} />
                                    </div>





                                    <div className={styles.select_box_container}>
                                        <div className={styles.detail_info}>
                                            <span className={styles.info_title}>학교/학과</span>
                                            {formData.universityPack
                                            .filter(box => box.status !== 'D' && box.status !== 'F')
                                            .map((box, index) => (
                                                <div className={styles.flex_box} key={box.idx}>
                                                    <input
                                                        type="text"
                                                        value={box.university}
                                                        placeholder="학교"
                                                        className={`${styles.info_cont_2}`}
                                                        onChange={(event) => handleSchoolChange(box.idx, 'university', event.target.value)} />
                                                    <input
                                                        type="text"
                                                        value={box.major}
                                                        placeholder="학과"
                                                        className={`${styles.info_cont_2}`}
                                                        onChange={(event) => handleSchoolChange(box.idx, 'major', event.target.value)} />
                                                    <select
                                                        className={`${styles.info_cont_2}`}
                                                        value={box.degree} // 학위에 대한 값
                                                        onChange={(event) => handleSchoolChange(box.idx, 'degree', parseInt(event.target.value, 10))} // 학위를 변경
                                                    >
                                                        <option value="1">학사</option>
                                                        <option value="2">석사</option>
                                                        <option value="3">박사</option>
                                                    </select>
                                                    <select
                                                        className={`${styles.info_cont_2}`}
                                                        value={box.degreeAttend} // 학위 상태에 대한 값
                                                        onChange={(event) => handleSchoolChange(box.idx, 'degreeAttend', parseInt(event.target.value, 10))} // 학위 상태를 변경
                                                    >
                                                        <option value="1">재학</option>
                                                        <option value="2">수료</option>
                                                        <option value="3">졸업</option>
                                                    </select>
                                                    {index === 0 ? (
                                                        <button onClick={() => handleAddUniversityBox('universityPack')} className={styles.add_button}></button>
                                                    ) : (
                                                        <button onClick={() => handleRemoveUniversityBox('universityPack', box.idx)} className={styles.remove_button}></button>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>





                                    <div className={styles.detail_info}>
                                        <span className={styles.info_title}>직장</span>
                                        <input type="text" name="job" placeholder='직장' value={formData.job} className={`${styles.info_cont}`} onChange={handleInputChange} />
                                    </div>







                                    <div className={styles.select_box_container}>
                                        <div className={styles.detail_info}>
                                            <span className={styles.info_title}>경력</span>
                                            {formData.careerPack
                                            .filter(box => box.status !== 'D' && box.status !== 'F')
                                            .map((box, index) => (
                                                <div className={styles.flex_box} key={box.idx}>
                                                    <input
                                                        type="text"
                                                        placeholder="경력"
                                                        value={box.career}
                                                        className={`${styles.info_cont} ${styles.info_statusIDX}`}
                                                        onChange={(event) => handleCareerChange(box.idx, 'career', event.target.value)}
                                                    />
                                                    {index === 0 ? (
                                                        <button onClick={handleAddCareerBox} className={styles.add_button}></button>
                                                    ) : (
                                                        <button onClick={() => handleRemoveCareerBox(box.idx)} className={styles.remove_button}></button>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>


                                    {/* <div className={styles.detail_info}>
                                        <span className={styles.info_title}>생성시간</span>
                                        <span className={`${styles.info_cont} ${styles.info_createTime}`}>{formData.createTime}</span>
                                    </div> */}
                                </div>
                                {/* detail_right_box */}









                            </div>

                            

                            <div className={styles.detail_info}>
                                <span className={`${styles.mypage_table_tit} ${styles.mgt_50}`}>행사참여 내역</span>
                            </div>

                            <div className={styles.mypage_table_box}>
                                <table className={styles.mypage_table}>
                                    <thead>
                                        <tr>
                                            <th className={styles.mypage_th_w_20}>구분</th>
                                            <th className={styles.mypage_th_w_60}>참여행사 목록</th>
                                            <th className={styles.mypage_th_w_20}>행사시작일</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {formData.eventHistory.map((event, index) => (
                                            <tr key={index}>
                                                <td className={styles.mypage_table_categoryName}>{event.categoryName}</td>
                                                <td className={styles.mypage_table_title}>{event.title}</td>
                                                <td className={styles.mypage_table_startDate}>{event.startDate || ''}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>








                            
                            <div className={styles.detail_info}>
                                <span className={`${styles.mypage_table_tit} ${styles.mgt_50}`}>작성한 게시글</span>
                            </div>



                            <div className={`${styles.mypage_table_box}`}>
                                <table className={styles.mypage_table}>
                                    <thead>
                                        <tr>
                                            <th className={styles.mypage_th_w_20}>구분</th>
                                            <th className={styles.mypage_th_w_60}>게시글 제목</th>
                                            <th className={styles.mypage_th_w_20}>작성일</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {formData.documentHistory.map((event, index) => (
                                            <tr 
                                                key={index} 
                                                className={styles.mypage_table_row} 
                                                onClick={() => window.location.href = `/noticedetail?id=${event.idx}&type=document`}
                                                style={{cursor: 'pointer'}}
                                            >
                                                <td className={styles.mypage_table_categoryName}>{event.documentCateroyName}</td>
                                                <td className={styles.mypage_table_title}>{event.title}</td>
                                                <td className={styles.mypage_table_startDate}>{event.createTime || ''}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            





















                            

                            {/* <div className={styles.detail_info}>
                                <span className={styles.info_title}>참여행사</span>
                                <button onClick={() => pModal('행사참여', eventHistoryData, '1200px', '600px')} className={`${styles.info_cont} ${styles.user_detail_btn}`}>참여내역</button>
                            </div> */}

                            <div className={styles.update_btn_box}>
                                <button onClick={() => handleSubmit()} className={`${styles.update_btn} `}>저장</button>
                            </div>
                        </div>
                    {/* ) : (
                        <div className={styles.detail_not_data}>잘못된 경로입니다.</div>
                    )} */}
                </div>
            </div>
        </>
    );
}

export default MyPage;